import EditorWrapper from '../../../Lexical/App';
const skipCollaborationInit =
  // @ts-expect-error
  window.parent != null && window.parent.frames.right === window;

export default function RichDescription({
  description,
}: {
  description: string;
}): JSX.Element {
  return (
    <>
      <div className={`editor-container `}>
        <EditorWrapper description={description} />
      </div>
    </>
  );
}
